<template>
  <div class="pa-10">
    <div style="height: 88vh; position: relative" class="overflow-y-auto">
      <v-container fluid class="pa-0">


        
        <!-- Profile Banner -->
        <v-card flat rounded="xl" class="profile-card mb-4">
          <div class="profile-banner" />
          <div class="pb-4 px-5">
            <div class="d-flex justify-space-between mt-n10 align-end">
              <div class="d-flex align-end ga-3">
                <div class="org-logo-box bg-white">
                  <v-icon size="56" color="#9ca3af">mdi-domain</v-icon>
                </div>
                <div class="pb-1">
                  <div class="profile-name">{{ name }}</div>
                  <div class="profile-desc">{{ description }}</div>
                </div>
              </div>
              <div class="d-flex align-end pb-1">
                <v-btn
                  variant="tonal"
                  color="#00A63E"
                  rounded="lg"
                  size="small"
                  prepend-icon="mdi-pencil-outline"
                  @click="editProfile"
                >
                  Edit Profile
                </v-btn>
              </div>
            </div>
            <v-divider class="mt-4 mb-3" />
            <div class="d-flex ga-6">
              <div class="d-flex align-center ga-1 profile-meta" v-if="address">
                <v-icon size="16" color="#9ca3af">mdi-map-marker-outline</v-icon>
                <span>{{ address }}</span>
              </div>
              <div class="d-flex align-center ga-1 profile-meta" v-if="website">
                <v-icon size="16" color="#9ca3af">mdi-web</v-icon>
                <span>{{ website }}</span>
              </div>
              <div class="d-flex align-center ga-1 profile-meta" v-if="email">
                <v-icon size="16" color="#9ca3af">mdi-email-outline</v-icon>
                <span>{{ email }}</span>
              </div>
            </div>
          </div>
        </v-card>

        <!-- Info Cards Row -->
        <v-row class="mb-4">
          <!-- About -->
          <v-col cols="4">
            <v-card flat rounded="xl" class="info-card pa-4" style="height: 100%;">
              <div class="info-card-header">
                <div class="d-flex align-center ga-2">
                  <div class="info-icon-box" style="background-color: #dcfce7;">
                    <v-icon size="14" color="#00A63E">mdi-information-outline</v-icon>
                  </div>
                  <span class="info-card-title">About the Company</span>
                </div>
              </div>
              <v-divider class="my-3" />
              <div class="info-body">{{ about_company || 'No description available.' }}</div>
            </v-card>
          </v-col>

          <!-- Contact Person -->
          <v-col cols="4">
            <v-card flat rounded="xl" class="info-card pa-4" style="height: 100%;">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center ga-2">
                  <div class="info-icon-box" style="background-color: #dbeafe;">
                    <v-icon size="14" color="#3b82f6">mdi-account-tie-outline</v-icon>
                  </div>
                  <span class="info-card-title">Contact Person</span>
                </div>
                <v-btn icon="mdi-pencil-outline" variant="text" size="x-small" color="grey" @click="editContactPerson" />
              </div>
              <v-divider class="my-3" />
              <div class="info-field-label">Name</div>
              <div class="info-field-value">{{ contact_person || '—' }}</div>
              <div class="info-field-label mt-3">Position</div>
              <div class="info-field-value">{{ contact_person_position || '—' }}</div>
              <div class="info-field-label mt-3">Phone</div>
              <div class="info-field-value">{{ phone_no || '—' }}</div>
            </v-card>
          </v-col>

          <!-- Head of Agency -->
          <v-col cols="4">
            <v-card flat rounded="xl" class="info-card pa-4" style="height: 100%;">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center ga-2">
                  <div class="info-icon-box" style="background-color: #fef9c3;">
                    <v-icon size="14" color="#ca8a04">mdi-shield-account-outline</v-icon>
                  </div>
                  <span class="info-card-title">Head of Agency</span>
                </div>
                <v-btn icon="mdi-pencil-outline" variant="text" size="x-small" color="grey" @click="editAgencyHead" />
              </div>
              <v-divider class="my-3" />
              <div class="info-field-label">Name</div>
              <div class="info-field-value">{{ head_of_agency || '—' }}</div>
              <div class="info-field-label mt-3">Phone</div>
              <div class="info-field-value">{{ head_of_agency_contact_no || '—' }}</div>
              <div class="info-field-label mt-3">E-Signature</div>
              <v-chip
                class="mt-1"
                size="small"
                variant="tonal"
                :color="hasEsig ? 'success' : 'default'"
              >
                <v-icon start size="12">{{ hasEsig ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                {{ hasEsig ? "Uploaded" : "Not Uploaded" }}
              </v-chip>
            </v-card>
          </v-col>
        </v-row>

        <!-- Institutes Tied -->
        <div class="mb-2">
          <div class="section-heading">Institutes Tied</div>
        </div>
        <v-row>
          <v-col cols="6" v-for="(i, idx) in getInstituteTied" :key="idx">
            <v-card flat rounded="xl" class="info-card pa-4">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center ga-2">
                  <div class="info-icon-box" style="background-color: #f0fdf4;">
                    <v-icon size="14" color="#00A63E">mdi-school-outline</v-icon>
                  </div>
                  <span class="info-card-title">{{ i.institute_name }}</span>
                </div>
                <v-btn
                  @click="editInternSlot(i)"
                  variant="tonal"
                  color="#00A63E"
                  size="x-small"
                  rounded="lg"
                  prepend-icon="mdi-pencil-outline"
                >Edit</v-btn>
              </div>
              <v-divider class="my-3" />
              <div class="d-flex flex-wrap ga-3">
                <div>
                  <div class="info-field-label">Programs</div>
                  <div class="info-field-value">{{ i.programs || '—' }}</div>
                </div>
                <div>
                  <div class="info-field-label">Intern Slots</div>
                  <div class="info-field-value">{{ i.slots }}</div>
                </div>
                <div>
                  <div class="info-field-label">Work Arrangement</div>
                  <v-chip size="x-small" variant="tonal" color="#00A63E" class="mt-1">{{ i.preferred_training_mode }}</v-chip>
                </div>
                <div>
                  <div class="info-field-label">Own Device Required</div>
                  <v-chip size="x-small" variant="tonal" :color="i.intern_should_have_own_device ? 'success' : 'default'" class="mt-1">
                    {{ i.intern_should_have_own_device ? 'Yes' : 'No' }}
                  </v-chip>
                </div>
              </div>
              <div class="mt-3" v-if="i.prefered_skills && i.prefered_skills.length > 0">
                <div class="info-field-label mb-1">Preferred Skills</div>
                <div class="d-flex flex-wrap ga-1">
                  <v-chip
                    size="x-small"
                    variant="tonal"
                    color="#00A63E"
                    class="px-2"
                    v-for="(item, ind) in i.prefered_skills"
                    :key="ind"
                  >{{ item }}</v-chip>
                </div>
              </div>
              <div class="mt-3" v-if="i.intern_should_have_own_device && i.deviceRequirements && i.deviceRequirements.length > 0">
                <div class="info-field-label mb-1">Device Requirements</div>
                <div class="d-flex flex-wrap ga-1">
                  <v-chip
                    size="x-small"
                    variant="tonal"
                    color="primary"
                    class="px-2"
                    v-for="(item, ind) in i.deviceRequirements"
                    :key="ind"
                  >{{ item }}</v-chip>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <UpdateCompanyProfileDialog :data="update_data" :action="action" />
    <UpdateCompanyContactPersonDialog
      :data="update_contact_person"
      :action="action"
    />

    <UpdateHeadofAgencyDialog :data="update_agency_head" :action="action" />
    <CompanyInsternSlotDialog :data="instituteToUpdate" :action="action" />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>
<script>
import CompanyInsternSlotDialog from "@/components/Dialogs/Forms/CompanyInsternSlotDialog.vue";
import UpdateCompanyContactPersonDialog from "@/components/Dialogs/Forms/UpdateCompanyContactPersonDialog.vue";
import UpdateCompanyProfileDialog from "@/components/Dialogs/Forms/UpdateCompanyProfileDialog.vue";
import UpdateHeadofAgencyDialog from "@/components/Dialogs/Forms/UpdateHeadofAgencyDialog.vue";

import eventBus from "@/eventBus";
export default {
  data() {
    return {
      instituteToUpdate: null,
      action: null,
      taggingData: null,
      isSelecting: false,
      selectFile: null,
      previewImg: null,
      tagGrade: null,
      tab: null,
      // items: ["Personal Information", "Login Info"],
      items: ["Personal Information"],
      totalYears: null,
      filter: null,
      name: null,
      address: null,
      description: null,
      website: null,
      email: null,
      contact_person: null,
      about_company: null,
      phone_no: null,
      contact_person_position: null,
      head_of_agency: null,
      head_of_agency_contact_no: null,
      hasEsig: false,
      update_data: null,
      oldPass: null,
      password: null,
      confirmPassword: null,
      showOldPass: false,
      show1: false,
      show2: false,
      institute_tied: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "System Message!",
        message: "",
        top: 10,
      },
      orgSlot: [],
      readonly: true,
      credentialReadonly: true,
      update_contact_person: null,
      update_agency_head: null,
    };
  },
  components: {
    UpdateCompanyProfileDialog,
    CompanyInsternSlotDialog,
    UpdateCompanyContactPersonDialog,
    UpdateHeadofAgencyDialog,
  },
  computed: {
    getInstituteTied() {
      let data = [];
      for (let i = 0; i < this.orgSlot.length; i++) {
        let progs = this.orgSlot[i].institute.programs;
        let progsName = "";
        if (progs && progs.length > 0) {
          for (let j = 0; j < progs.length; j++) {
            progsName += j == 0 ? progs[j].abbr : ", " + progs[j].abbr;
          }
        }
        data.push({
          orgSlotId: this.orgSlot[i].id,
          institute_name: this.orgSlot[i].institute.name,
          institute_id: this.orgSlot[i].institute_id,
          slots: this.orgSlot[i].slots,
          programs: progsName,
          deviceRequirements: this.orgSlot[i].intern_device_requirement,
          intern_should_have_own_device:
            this.orgSlot[i].intern_should_have_own_device,
          prefered_skills: this.orgSlot[i].prefered_skills,
          preferred_training_mode: this.orgSlot[i].preferred_training_mode,
        });
      }
      return data;
    },
  },
  mounted() {
    this.initialize();
    eventBus.on("closeUpdateCompanyProfileDialog", () => {
      this.initialize();
    });
    eventBus.on("closeUpdateCompanyContactPersonDialog", () => {
      this.initialize();
    });

    eventBus.on("closeCompanyInsternSlotDialog", () => {
      this.initialize();
    });
    eventBus.on("closeUpdateHeadofAgencyDialog", () => {
      this.initialize();
    });
  },
  beforeUnmount() {
    eventBus.off("closeUpdateCompanyProfileDialog");
    eventBus.off("closeCompanyInsternSlotDialog");
    eventBus.off("closeUpdateCompanyContactPersonDialog");
    eventBus.off("closeUpdateHeadofAgencyDialog");
  },
  methods: {
    initialize() {
      this.axiosCall("/organization/getInfo", "GET").then((res) => {
        if (res.data) {
          console.log("ORG INIT", res.data);
          this.name = res.data.name;
          this.address = res.data.address;
          this.description = res.data.description;
          this.website = res.data.website;
          this.email = res.data.email;
          this.contact_person = res.data.contact_person;
          this.phone_no = res.data.phone_no;
          this.contact_person_position = res.data.contact_person_position;
          this.about_company = res.data.about_company;
          this.orgSlot = res.data.org_slot;
          this.institute_tied = res.data.institute_tied;
          this.head_of_agency = res.data.head_of_agency;
          this.head_of_agency_contact_no = res.data.head_of_agency_contact_no;
          this.hasEsig = res.data.head_of_agency_esig ? true : false;
        }
      });
    },

    editProfile() {
      this.update_data = { id: null };
      this.action = "Update";
    },

    editContactPerson() {
      this.update_contact_person = { id: null };
      this.action = "Update";
    },

    editAgencyHead() {
      this.update_agency_head = { id: null };
      this.action = "Update";
    },

    editInternSlot(item) {
      this.instituteToUpdate = item;
      this.action = "Update";
    },

    updateCredential() {
      if (this.$refs.loginInfo.validate()) {
        let data = {
          old_password: this.oldPass,
          new_password: this.password,
        };
        this.axiosCall("/auth/changePass", "POST", data).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.password = null;
            this.confirmPassword = null;
            this.credentialReadonly = true;
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.show = true;
          }
        });
      }
    },

    updateProfile() {
      if (this.$refs.personalInfo.validate()) {
        const fd = new FormData();
        this.axiosCall("/user-details/updateUser", "POST", this.data).then(
          (res) => {
            if (res.data.status == 200) {
              if (this.selectFile) {
                fd.append("file", this.selectFile);
                this.axiosCall("/user-details/uploadimage", "POST", fd).then(
                  (resp) => {
                    if (resp.data.status == 200) {
                      this.initialize();
                      this.fadeAwayMessage.message = resp.data.msg;
                      this.fadeAwayMessage.show = true;
                      this.readonly = true;
                      this.$emit("reloadProfile");
                    } else if (resp.data.status == 400) {
                      this.initialize();
                      this.fadeAwayMessage.message = resp.data.msg;
                      this.fadeAwayMessage.show = true;
                      this.readonly = true;
                    }
                  },
                );
              } else {
                this.initialize();
                this.fadeAwayMessage.message = res.data.msg;
                this.fadeAwayMessage.show = true;
                this.readonly = true;
              }
            } else if (res.data.status == 400) {
              this.initialize();
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.show = true;
              this.readonly = true;
            }
          },
        );
      }
    },

    handleFileImport() {
      let fileUpload = document.getElementById("fileUpload");
      if (fileUpload != null) {
        fileUpload.click();
      }
    },
    onFileChanged() {
      const uploadedimg = document.getElementById("fileUpload").files[0];
      this.selectFile = uploadedimg;

      this.previewImg = URL.createObjectURL(uploadedimg);
      this.isSelecting = true;
    },
  },
  created() {
    this.initialize();
    // console.log("created");
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
      // location.reload();
    }
  },
};
</script>
<style scoped>
.profile-card {
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}
.profile-banner {
  background-image: linear-gradient(to right, #00a63e, #016630);
  height: 100px;
}
.org-logo-box {
  width: 84px;
  height: 84px;
  border-radius: 12px;
  border: 3px solid #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.profile-name {
  font-size: 18px;
  font-weight: 800;
  color: #111827;
}
.profile-desc {
  font-size: 13px;
  color: #6b7280;
  margin-top: 1px;
}
.profile-meta {
  font-size: 12.5px;
  color: #6b7280;
}
.info-card {
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}
.info-icon-box {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.info-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}
.info-body {
  font-size: 13px;
  color: #4b5563;
  line-height: 1.6;
}
.info-field-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #9ca3af;
}
.info-field-value {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
  margin-top: 2px;
}
.section-heading {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 8px;
}
</style>
